module.exports = __webpack_public_path__ + "img/50-a38501.png";